import { useState } from 'react';

export default function Gallery() {
  const [activeTab, setActiveTab] = useState('photos');
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState('');

  const photos = [
    {
      title: 'Xe 56 chỗ ADT Tour Bus',
      image: 'https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/3ffb0e07daadb239f01404487d9a2059.jpeg'
    },
    {
      title: 'Xe Ford Expedition cao cấp',
      image: 'https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/f9b3baf7dc9f6d378cf6e458bdf2656e.jpeg'
    },
    {
      title: 'Đội xe du lịch chuyên nghiệp',
      image: 'https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/b65efcb8e2c8a02849c079d85bf91490.jpeg'
    },
    {
      title: 'Đội xe trên tuyết',
      image: 'https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/b65efcb8e2c8a02849c079d85bf91490.jpeg'
    },
    {
      title: 'Xe 7 chỗ cao cấp',
      image: 'https://public.readdy.ai/ai/img_res/93fa7834b8b5f79a50ece17c10429c6e.jpg'
    },
    {
      title: 'Xe 15 chỗ mini bus',
      image: 'https://readdy.ai/api/search-image?query=15-passenger%20mini%20bus%20interior%20with%20comfortable%20seating%20and%20luggage%20space%2C%20modern%20commercial%20vehicle%20interior%2C%20clean%20simple%20background%2C%20professional%20automotive%20photography&width=600&height=400&seq=vehicle-interior-15-001&orientation=landscape'
    },
    {
      title: 'Xe 25 chỗ sprinter',
      image: 'https://readdy.ai/api/search-image?query=25-passenger%20sprinter%20van%20interior%20with%20luxury%20seating%20arrangement%20and%20ample%20legroom%2C%20modern%20tour%20vehicle%20interior%2C%20clean%20simple%20background%2C%20professional%20automotive%20photography&width=600&height=400&seq=vehicle-interior-25-001&orientation=landscape'
    },
    {
      title: 'Khoang hành lý rộng',
      image: 'https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/c809c1e482894f67ac941e0d09378892.jpeg'
    },
    {
      title: 'Xe chạy trên highway',
      image: 'https://readdy.ai/api/search-image?query=Tour%20bus%20driving%20on%20scenic%20American%20highway%20through%20desert%20landscape%2C%20professional%20transportation%20on%20open%20road%2C%20western%20United%20States%20highway%2C%20clean%20simple%20background%2C%20professional%20travel%20photography&width=600&height=400&seq=vehicle-highway-001&orientation=landscape'
    },
    {
      title: 'Đội ngũ lái xe chuyên nghiệp',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20tour%20bus%20driver%20in%20uniform%20standing%20next%20to%20luxury%20coach%20bus%2C%20friendly%20smile%2C%20welcoming%20gesture%2C%20clean%20simple%20background%2C%20professional%20portrait%20photography&width=600&height=400&seq=driver-portrait-001&orientation=landscape'
    },
    {
      title: 'Driver guide tiếng Việt',
      image: 'https://readdy.ai/api/search-image?query=Vietnamese%20tour%20guide%20with%20tourist%20group%20at%20famous%20American%20landmark%2C%20professional%20guide%20explaining%20to%20visitors%2C%20friendly%20interaction%2C%20clean%20simple%20background%2C%20professional%20travel%20photography&width=600&height=400&seq=driver-guide-001&orientation=landscape'
    },
    {
      title: 'Đón khách tại sân bay',
      image: 'https://readdy.ai/api/search-image?query=Professional%20driver%20holding%20welcome%20sign%20at%20airport%20arrival%20area%2C%20luxury%20vehicle%20in%20background%2C%20airport%20pickup%20service%2C%20clean%20simple%20background%2C%20professional%20service%20photography&width=600&height=400&seq=driver-airport-001&orientation=landscape'
    }
  ];

  const videos = [
    {
      title: 'Công ty Du lịch Khám Phá Mỹ',
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20tour%20bus%20fleet%20parked%20in%20organized%20rows%20at%20company%20depot%2C%20multiple%20luxury%20coaches%2C%20modern%20transportation%20company%2C%20clean%20simple%20background%2C%20professional%20business%20photography&width=600&height=400&seq=video-fleet-001&orientation=landscape',
      duration: '3:45',
      videoUrl: 'https://www.youtube.com/embed/PwpZwYAygfI?autoplay=1'
    },
    {
      title: 'Nội thất xe 56 chỗ cao cấp',
      thumbnail: 'https://readdy.ai/api/search-image?query=Interior%20walkthrough%20of%2056-passenger%20luxury%20tour%20coach%20with%20reclining%20seats%20and%20entertainment%20system%2C%20modern%20bus%20interior%2C%20premium%20amenities%2C%20clean%20simple%20background%2C%20professional%20video%20thumbnail&width=600&height=400&seq=video-interior-56-001&orientation=landscape',
      duration: '2:30',
      videoUrl: 'https://www.youtube.com/embed/QwBp9jYLEEI?autoplay=1'
    },
    {
      title: 'Hành trình Grand Canyon',
      thumbnail: 'https://readdy.ai/api/search-image?query=Tour%20bus%20traveling%20through%20stunning%20Grand%20Canyon%20landscape%20with%20red%20rock%20formations%2C%20scenic%20American%20Southwest%20journey%2C%20beautiful%20desert%20scenery%2C%20clean%20simple%20background%2C%20professional%20travel%20videography&width=600&height=400&seq=video-grandcanyon-001&orientation=landscape',
      duration: '5:20',
      videoUrl: 'https://www.youtube.com/embed/boJfomfYyVE?autoplay=1'
    },
    {
      title: 'Dịch vụ đón tiễn sân bay',
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20airport%20pickup%20service%20with%20driver%20greeting%20passengers%20at%20terminal%2C%20luxury%20vehicle%20waiting%20area%2C%20efficient%20transportation%20service%2C%20clean%20simple%20background%2C%20professional%20service%20video&width=600&height=400&seq=video-airport-001&orientation=landscape',
      duration: '2:15',
      videoUrl: 'https://www.youtube.com/embed/8Q1bQ08gu9w?autoplay=1'
    },
    {
      title: 'Tour Las Vegas - Los Angeles',
      thumbnail: 'https://readdy.ai/api/search-image?query=Tour%20bus%20journey%20from%20Las%20Vegas%20to%20Los%20Angeles%20showing%20iconic%20landmarks%20and%20highway%20scenery%2C%20popular%20California%20Nevada%20route%2C%20beautiful%20travel%20footage%2C%20clean%20simple%20background%2C%20professional%20travel%20video&width=600&height=400&seq=video-vegas-la-001&orientation=landscape',
      duration: '4:50',
      videoUrl: 'https://www.youtube.com/embed/TpH2e1QfSPQ?autoplay=1'
    },
    {
      title: 'Đánh giá từ khách hàng',
      thumbnail: 'https://readdy.ai/api/search-image?query=Happy%20Vietnamese%20tourists%20giving%20testimonial%20inside%20tour%20bus%2C%20satisfied%20customers%20sharing%20positive%20experience%2C%20friendly%20group%20photo%2C%20clean%20simple%20background%2C%20professional%20testimonial%20video&width=600&height=400&seq=video-testimonial-001&orientation=landscape',
      duration: '3:10',
      videoUrl: 'https://www.youtube.com/embed/z-GXel8L4kU?autoplay=1'
    }
  ];

  const handleVideoClick = (videoUrl: string) => {
    setSelectedVideoUrl(videoUrl);
    setIsVideoOpen(true);
  };

  return (
    <>
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Hình Ảnh &amp; Video
            </h2>
            <p className="text-lg sm:text-xl text-gray-700 max-w-3xl mx-auto font-medium">
              Khám phá đội xe và dịch vụ của chúng tôi qua hình ảnh và video thực tế
            </p>
          </div>

          {/* Tab Switcher */}
          <div className="flex justify-center mb-12">
            <div className="inline-flex bg-gray-100 rounded-full p-1">
              <button
                onClick={() => setActiveTab('photos')}
                className={`whitespace-nowrap px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg transition-all duration-300 cursor-pointer ${
                  activeTab === 'photos'
                    ? 'bg-blue-900 text-white shadow-lg'
                    : 'text-gray-700 hover:text-gray-900'
                }`}
              >
                <i className="ri-image-line mr-2 text-xl"></i>
                Hình Ảnh
              </button>
              <button
                onClick={() => setActiveTab('videos')}
                className={`whitespace-nowrap px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg transition-all duration-300 cursor-pointer ${
                  activeTab === 'videos'
                    ? 'bg-blue-900 text-white shadow-lg'
                    : 'text-gray-700 hover:text-gray-900'
                }`}
              >
                <i className="ri-video-line mr-2 text-xl"></i>
                Video
              </button>
            </div>
          </div>

          {/* Photos Grid */}
          {activeTab === 'photos' && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {photos.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
                >
                  <div className="h-48 sm:h-64 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5 sm:p-6">
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900">
                      {item.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Videos Grid */}
          {activeTab === 'videos' && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {videos.map((item, index) => (
                <div
                  key={index}
                  onClick={() => handleVideoClick(item.videoUrl)}
                  className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
                >
                  <div className="h-48 sm:h-64 overflow-hidden relative">
                    <img
                      src={item.thumbnail}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                      <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-white/90 rounded-full group-hover:bg-blue-900 group-hover:text-white transition-all duration-300">
                        <i className="ri-play-fill text-3xl sm:text-4xl"></i>
                      </div>
                    </div>
                    <div className="absolute bottom-4 right-4 bg-black/80 text-white px-3 py-1.5 rounded-lg text-sm sm:text-base font-bold">
                      <i className="ri-time-line mr-1"></i>
                      {item.duration}
                    </div>
                  </div>
                  <div className="p-5 sm:p-6">
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900">
                      {item.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="text-center mt-12">
            <button
              className="whitespace-nowrap bg-green-600 hover:bg-green-700 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-bold transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-gallery-line mr-2 text-xl"></i>
              Xem thêm hình ảnh &amp; video
            </button>
          </div>
        </div>
      </section>

      {/* Video Popup Modal */}
      {isVideoOpen && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setIsVideoOpen(false)}
        >
          <div 
            className="relative w-full max-w-5xl aspect-video"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setIsVideoOpen(false)}
              className="absolute -top-12 right-0 text-white hover:text-red-500 transition-colors cursor-pointer"
            >
              <i className="ri-close-circle-fill text-4xl"></i>
            </button>
            <iframe
              className="w-full h-full rounded-lg"
              src={selectedVideoUrl}
              title="Video giới thiệu dịch vụ"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
}
